import { useEffect, useState } from 'react';
import { sharedStore } from '@ncl/rootStore/rootStore.model';
import * as services from './useExperiment.services';

export default function useExperiment(name) {
  const [ready, setReady] = useState(false);
  const [variant, setVariant] = useState(0);

  useEffect(() => {
    services.waitForGTag(gTagCallback);
  }, []);

  function gTagCallback(success) {
    if (!success) {
      setReady(true);
      return;
    }

    initializeExperiment();
  }

  async function initializeExperiment() {
    try {
      const activeVariant = await services.activateExperiment(name);
      setVariant(activeVariant);
      sharedStore.setExperiment({ id: name, activeVariant: +activeVariant });
    } catch (error) {
      console.error(error);
    } finally {
      setReady(true);
    }
  }

  return [ready, variant];
}
